/**
 * Blocklist property types
 */
export type BlocklistProperty = 'cpf' | 'cnpj' | 'email' | 'celular' | 'telefone';

/**
 * Blocklist item from API
 */
export interface BlocklistItem {
  id: string;
  property: BlocklistProperty;
  valueProperty: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

/**
 * Pagination info from API
 */
export interface PaginationInfo {
  page: number;
  limit: number;
  totalItems: number;
  totalPages: number;
}

/**
 * Blocklist list response from API
 */
export interface BlocklistListResponse {
  data: BlocklistItem[];
  pagination: PaginationInfo;
}

/**
 * Blocklist query params
 */
export interface BlocklistQueryParams {
  page?: number;
  limit?: number;
  search?: string;
  property?: BlocklistProperty;
  isActive?: boolean;
}

/**
 * Map UI tab to API property
 */
export const TAB_TO_PROPERTY: Record<string, BlocklistProperty> = {
  CNPJ: 'cnpj',
  CPF: 'cpf',
  Email: 'email',
  Telefone: 'telefone',
  Celular: 'celular',
};

/**
 * Map API property to display label
 */
export const PROPERTY_LABELS: Record<BlocklistProperty, string> = {
  cnpj: 'CNPJ',
  cpf: 'CPF',
  email: 'Email',
  celular: 'Celular',
  telefone: 'Telefone',
};

/**
 * Blocklist category types
 */
export type BlocklistCategory = string;

/**
 * Blocklist categories response from API (array of strings)
 */
export type BlocklistCategoriesResponse = string[];

/**
 * Request to create a blocklist item
 */
export interface CreateBlocklistRequest {
  property: BlocklistProperty;
  valueProperty: string;
  category: BlocklistCategory;
  reason: string;
}

/**
 * Response from create blocklist API
 */
export interface CreateBlocklistResponse {
  id: string;
  property: BlocklistProperty;
  valueProperty: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

/**
 * Request to deactivate a blocklist item
 */
export interface DeactivateBlocklistRequest {
  id: string;
  reason: string;
}

/**
 * Response from deactivate blocklist API
 */
export interface DeactivateBlocklistResponse {
  id: string;
  property: BlocklistProperty;
  valueProperty: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}
